'use strict';

const breakpoints = {
    'maxMobile': 767,
    'maxTablet': 1024,
    'maxHeaderTablet': 1125
};

export default breakpoints;
